import { path } from 'd3-path'
import Symbol2d from '../2d.js'

export default class Diamond extends Symbol2d {

  path (dimensions) {
    const _path = path()
    _path.moveTo(dimensions.width / 2, 0) // Top center
    _path.lineTo(dimensions.width, dimensions.height / 2) // Right middle
    _path.lineTo(dimensions.width / 2, dimensions.height) // Bottom center
    _path.lineTo(0, dimensions.height / 2) // Left middle
    _path.closePath()
    return _path.toString()
  }

  textContainer (dimensions) {
    // Find the midpoint of the top left line
    const l1 = [0, dimensions.height / 2]
    const l2 = [dimensions.width / 2, 0]

    // Find the midpoint between l1 and l2
    const x = (l1[0] + l2[0]) / 2
    const y = (l1[1] + l2[1]) / 2

    const width = (dimensions.center[0] - x) * 2
    const height = (dimensions.center[1] - y) * 2

    return {
      height,
      width,
      center: dimensions.center
    }
  }

}
